import React from 'react';
import LinkedInLoginImage from './images/linkedinlogin.png';

const LinkedInAuthButton = () => {
  const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_LINKEDIN_REDIRECT;
  const state = crypto.randomUUID(); // More secure state value
  const scope = ['openid', 'profile', 'email'].join('%20');

  const handleLinkedInLogin = () => {
    if (!clientId || !redirectUri) {
      console.error("❌ Missing LinkedIn client ID or redirect URI.");
      alert("LinkedIn login is not configured correctly.");
      return;
    }

    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&state=${state}&scope=${scope}`;

    window.location.href = authUrl;
  };

  return (
    <div onClick={handleLinkedInLogin} style={{ cursor: 'pointer' }} title="Log in with LinkedIn">
      <img
        src={LinkedInLoginImage}
        alt="Log in with LinkedIn"
        width="50%"
        height="auto"
        style={{ maxWidth: 250 }}
      />
    </div>
  );
};

export default LinkedInAuthButton;
